import React from 'react';
import { useMount } from '@shared/utils/hooks/useMount';
import { useHotelBookingGuestSiteTelemetry } from '../../HotelBooking.telemetry';
import { useHotelBookingRedirectHealth, wrapWithHotelBookingRedirectProvider } from '../../HotelBooking.health';
import { useEventDisplayName } from '@shared/utils/eventInfo/useEventDisplayName';
import { useHotelSearchConfig } from './useHotelSearchConfig';
import { useQueryParamHelper } from '@shared/core/queryString';
import { HotelSearchContextParams, HotelSearchSource } from '@shared/constants/accommodations';

import { LazyGuestAccommodationsConsole } from '@apps/stays/AccommodationsConsole/scenarios/guest/GuestAccommodationsConsole.lazy';
import { LazyOtaAccommodationsConsole } from '@apps/stays/AccommodationsConsole/scenarios/ota/OtaAccommodationsConsole.lazy';

export const HotelSearch = wrapWithHotelBookingRedirectProvider(({ eventHandle }: { eventHandle: string }) => {
  const { onLoadComplete } = useHotelBookingRedirectHealth();
  const telemetry = useHotelBookingGuestSiteTelemetry();
  const eventDisplayName = useEventDisplayName();
  const queryParamHelper = useQueryParamHelper();

  const { source, layout } = useHotelSearchConfig();

  const selectedHotelId = queryParamHelper.getValueString(HotelSearchContextParams.selectedHotel) || undefined;

  useMount(() => {
    onLoadComplete();
    telemetry.hotelSearch.enter();
  });

  if (source === HotelSearchSource.GUEST_MAP) {
    return (
      <LazyGuestAccommodationsConsole
        eventHandle={eventHandle}
        eventName={eventDisplayName}
        selectedHotelId={selectedHotelId}
        layout={layout}
      />
    );
  }

  return (
    <LazyOtaAccommodationsConsole
      eventHandle={eventHandle}
      eventName={eventDisplayName}
      selectedHotelId={selectedHotelId}
      layout={layout}
    />
  );
});
